import "../styles/styles.css";
import React, { useState, useCallback, useMemo } from "react";
import qs from "qs";
import { useDispatch, useSelector } from "react-redux";
import ClientPageTabs from "../components/clients-page/ClientPageTabs";
import { CircularProgress, Divider, Grid } from "@material-ui/core";
import Form, { Item, GroupItem } from "devextreme-react/form";
import { getUIProperty, setUIProperty } from "../redux/slices/uiSlice";
import { API_URL } from "../components/search/config";
import CustomSelection from "../components/generic/CustomSelection";
import useResourceStatuses from "../hooks/useResourceStatus";
import { openAuthorizedWindow } from "../utils/api";
import Loader from "../components/generic/Loader";

const getAvailableYears = () => {
  const availableYears = [];

  const currentYear = new Date().getFullYear();

  for (let i = 2000; i <= currentYear; i++) availableYears.push(i);

  return availableYears;
};

const ClientsPage = () => {
  const clientId = useSelector((state) => getUIProperty(state, "clientId"));
  const dispatch = useDispatch();
  const { clientStatus } = useResourceStatuses();

  const [reportReady, setReportReady] = useState(true);

  const availableYears = useMemo(() => getAvailableYears(), []);

  const [summaryData, setSummaryData] = useState({});

  const createSummary = useCallback(
    async (type) => {
      let url = "";
      switch (type) {
        case "total":
          url = `client/${clientId}/total_summary_report/?${qs.stringify(
            summaryData
          )}`;
          break;
        case "credit":
          url = `total_summary_report`;
          break;

        case "account":
          url = summaryData.useAllAccountSummary
            ? `client/all_clients_summary_report/`
            : `client/${clientId}/account_summary_report/`;
          break;

        default:
      }

      const { fileName, pdfUrl } = await openAuthorizedWindow(
        `${API_URL}/resource/${url}`,
        setReportReady
      );

      dispatch(setUIProperty({ name: "pdfUrl", value: pdfUrl }));
      dispatch(setUIProperty({ name: "fileName", value: fileName }));
    },
    [clientId, dispatch, summaryData]
  );

  return (
    <div>
      {!reportReady && <Loader style={{ marginLeft: "-10%" }} />}
      <Grid
        item
        container
        xs={12}
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Grid item>
          <h2>Select Client : </h2>
        </Grid>
        <Grid item xs={3}>
          {clientStatus === "idle" && <CircularProgress />}
          <CustomSelection
            valueExpr="id"
            value={clientId}
            resourceName="clients"
            resourcePath="client"
            handleChange={(e) =>
              dispatch(setUIProperty({ name: "clientId", value: e.value }))
            }
          />
        </Grid>
      </Grid>
      <Form
        onFieldDataChanged={(e) => {
          const { dataField, value } = e;

          return setSummaryData((prevFormData) => ({
            ...prevFormData,
            [dataField]: value,
          }));
        }}
        labelLocation="left"
        onContentReady={(e) => e.component.validate()}
        colCount={2}
        id="form"
      >
        <GroupItem caption="Total Summary" colCount={2}>
          <Item
            dataField="year"
            editorType="dxSelectBox"
            editorOptions={{
              items: availableYears,
              searchEnabled: true,
              value: summaryData.year,
            }}
          />
          <Item
            dataField="ss"
            itemType="button"
            horizontalAlignment="left"
            buttonOptions={{
              disabled: !clientId,
              text: "Total Summary",
              type: "success",
              onClick: () => createSummary("total"),
            }}
          />
        </GroupItem>
        <GroupItem caption="Account Summary" colCount={3}>
          <Item
            editorOptions={{
              value: summaryData.daysPassed,
              disabled: !summaryData.useAllAccountSummary,
              showSpinButtons: true,
            }}
            editorType="dxNumberBox"
            dataField="daysPassed"
          />
          <Item dataField="useAllAccountSummary" editorType="dxCheckBox" />
          <Item
            itemType="button"
            horizontalAlignment="left"
            buttonOptions={{
              disabled: !clientId && !summaryData.useAllAccountSummary,
              text: "Account Summary",
              type: "success",
              onClick: () => createSummary("account"),
            }}
          />
        </GroupItem>
      </Form>
      <Divider />
      <ClientPageTabs />
    </div>
  );
};

export default ClientsPage;
